import React from 'react';
import './AboutUs.css';

const AboutUs = () => {
  return (
    <section id="about-section" className="about-container">
      <div className="about-inner">
        {/* About Us Header */}
        <div className="about-header">
          <h2 id="about-title" className="about-title">About Eskista</h2>
          <div className="about-divider"></div>
          <p id="about-description" className="about-description">
            
Eskista is Ethiopia’s premier rental service for professional video, photo, and audio equipment. Since 2019, we have proudly served as a trusted partner for creative professionals—offering top-tier gear and reliable support to help bring their visions to life.



          </p>

          <p id="about-description" className="about-description">From filmmakers, broadcasters, and production houses to marketing agencies, photographers, content creators, and event organizers, our diverse clientele counts on Eskista for high-quality equipment and a seamless rental experience.</p>
          <p id="about-description" className="about-description">At Eskista, we are committed to empowering storytellers by providing not just tools—but value-added services like expert consultation, logistics, and talent sourcing. Whether it’s a single shoot or a full-scale production, we’re here to support your creative journey with professionalism and care.</p>
        </div>
        
        {/* Services Cards */}
        <div id="about-services" className="about-services-grid">
          {/* Rental Services Card */}
          <div id="about-rental-card" className="about-card">
            {/* <div className="about-card-icon">🎥</div> */}
            <h3 className="about-card-title"> Rental Service (Equipment & Studio)</h3>
            <p className="about-card-description">
              Eskista provides premium video, photo, audio, and lighting equipment rentals alongside professional studio spaces designed for creative productions of all scales. From high-end cameras and lenses to fully equipped studios with lighting and sound solutions, we ensure your production has the tools and environment it needs to succeed. Our gear is regularly maintained and updated, and our studios offer flexible setups for filmmaking, photography, podcasts, and other creative projects.
            </p>
          </div>

          {/* Subrenting Card */}
          <div id="about-subrenting-card" className="about-card">
            {/* <div className="about-card-icon">🤝</div> */}
            <h3 className="about-card-title">Talent Hiring</h3>
            <p className="about-card-description">
              Eskista connects you with a network of skilled professionals across the creative industry, including cinematographers, lighting experts, makeup artists, stylists, and on-screen talent. Whether you need a full production crew or specific cast members, we match the right people to your project, ensuring quality performance and smooth collaboration. This service saves you time on recruitment while guaranteeing professional results.
            </p>
          </div>

          {/* Talents Card */}
          <div id="about-talents-card" className="about-card">
            {/* <div className="about-card-icon">🌟</div> */}
            <h3 className="about-card-title">On-Demand Consultation</h3>
            <p className="about-card-description">
              Our on-demand consultation service offers expert guidance for all stages of your creative project—whether you’re planning a film shoot, setting up for a live event, or producing marketing content. Eskista’s team advises on equipment selection, crew requirements, set design, and production logistics, helping you make cost-effective and creative decisions that bring your vision to life.
            </p>
          </div>

          {/* Logistics Card */}
          <div id="about-logistics-card" className="about-card">
            {/* <div className="about-card-icon">🚚</div> */}
            <h3 className="about-card-title">Props & Costume Rental</h3>
            <p className="about-card-description">
              Eskista provides a curated selection of props and costumes to enhance the authenticity and style of your productions. From traditional Ethiopian attire to modern set pieces, our collection is perfect for filmmakers, photographers, and event planners seeking that extra touch of detail. We ensure all items are well-maintained and ready to complement your creative vision.

            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;